import type { HttpInterceptorFn } from '@angular/common/http';
import { IS_INIT_SESSION } from '@copec-gid/gid-arquitectura.seguridad-autorizacion-modulo';

export const SESSION_TOKEN_HEADER = 'sessiontoken';

export const sessionHeaderInterceptor: HttpInterceptorFn = (request, next) =>
  request.context.get(IS_INIT_SESSION) || !request.headers.has(SESSION_TOKEN_HEADER)
    ? next(request)
    : next(request.clone({ headers: request.headers.delete(SESSION_TOKEN_HEADER) }));
